module.exports = {
      id: "comm-environment-usage",
      viewBox: "0 0 276.484 47.102",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#comm-environment",
      toString: function () {
        return this.url;
      }
    }